import {
  useTheme,
  Box,
  Button,
  Popper,
  ClickAwayListener,
} from '@mui/material';
import { tokens } from '../../../../global/theme/tokens';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useEffect, useState } from 'react';
import { Calendar } from '../cal-list/ExoCalList';
import Cookies from 'universal-cookie';
import { ExoSkeleton } from '../../ExoSkeleton';

const CalendarSelect = ({
  calendars,
  onSelect,
  selectedCal,
  size = 'small',
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const nextYear = new Date();
  nextYear.setFullYear(nextYear.getFullYear() + 1);
  const cookies = new Cookies();
  const selectedCalId = cookies.get('selectedCalId');

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);

  function handleSelect(cal, isInit) {
    if (!cal) return;
    onSelect(cal, isInit);
    setAnchorEl(null);
    cookies.set('selectedCalId', cal.id, {
      path: '/',
      expires: nextYear,
    });
  }

  // calendar
  useEffect(() => {
    if (calendars && !selectedCal) {
      var newSelectedCal = null;
      calendars.forEach((cal) => {
        if (!newSelectedCal && cal.id) {
          if (selectedCalId) {
            //preselect from cookies
            if (selectedCalId == cal.id)
              newSelectedCal = { name: cal.name, id: cal.id, color: cal.color };
          } else {
            //
            if (!newSelectedCal && cal.id)
              newSelectedCal = { name: cal.name, id: cal.id, color: cal.color };
          }
        }
      });
      handleSelect(newSelectedCal, true);
    }
  }, [calendars, selectedCalId]);

  const isSmall = size === 'small';

  if (!calendars)
    return (
      <Box className="flex gap-2 pb-2">
        <Box
          sx={{
            margin: '0px',
            padding: '5px',
            bgcolor: colors.card,
            borderRadius: '8px',
            minWidth: '30px',
            minHeight: '30px',
          }}
        >
          <CalendarMonthIcon sx={{ fontSize: isSmall ? '20px' : '30px' }} />
        </Box>
        <ExoSkeleton size="28px" className="w-full" />
      </Box>
    );

  return (
    <Box className="flex gap-2 pb-2">
      <Button
        onClick={handleClick}
        sx={{
          margin: '0px',
          padding: '5px',
          bgcolor: colors.card,
          borderRadius: '8px',
          minWidth: '30px',
          minHeight: '30px',
        }}
      >
        <CalendarMonthIcon sx={{ fontSize: isSmall ? '20px' : '30px' }} />
      </Button>
      {selectedCal && <Calendar cal={selectedCal} noIcon size={size} />}
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        sx={{
          zIndex: 9999,
        }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Box
            sx={{
              backgroundColor: colors.card,
              border: `1px solid ${colors.selected}`,
            }}
            className="flex flex-col backdrop-blur-md rounded-md"
          >
            {calendars?.map(
              (cal) =>
                cal.writePermissions &&
                Boolean(cal.id) && (
                  <Calendar
                    cal={cal}
                    key={cal.id}
                    noIcon
                    onSelect={handleSelect}
                  />
                )
            )}
          </Box>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default CalendarSelect;
